<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-29 16:38:13
 * @LastEditors: 陈钊贤
 * @Description: 
 * @LastEditTime: 2020-07-14 10:13:30
--> 
<template>
  <pi-content class="my-card">
    <div class="card-list">
    <ul>
      <li class="card-list-item" :class="{'op4':item.status == 0}" v-for="(item,index) in cardList" :key="index">
        <div class="card-status">{{item.status == 1 ? '关联卡': '已取消的关联卡'}}</div>
        <div class="card-number">{{item.cardPkId}}</div>
      </li>
      <li class="no-card" v-if="cardList.length == 0">暂无关联充电卡</li>
    </ul>
    <div class="btn-box">
    <pi-button block @click="clearCard" v-if="btnShow">
        取消关联
      </pi-button>
      </div>
    </div>
  </pi-content>
</template>
<script>
import { getCardList, unbindCard } from '@/common/api'
export default {
  name: 'my-card',
  data(){
    return{
      cardList: [],
      btnShow: false
    }
  },
  methods: {
    clearCard(){
      this.$dialog
        .confirm({
          message: "取消之后，充电卡将无法使用",
          confirmButtonText: "取消",
          confirmButtonColor: "#999999",
          cancelButtonColor: "#14CC80",
           cancelButtonText: "注销",
          closeOnPopstate: true
        })
        .then(() => {

        }).catch(() => {
          console.log("??")
          let cardPkId = '';
          this.cardList.map(item=>{
            if(item.status == 1 && cardPkId == ''){
              cardPkId = item.cardPkId
            }
          })
          this.unbindCard(cardPkId)
        });
    },
    unbindCard(cardPkId){
      unbindCard({cardPkId: cardPkId}).then(ret=>{
        if (ret.status == this.$config.ajaxStatus){
          this.getCardList();
          this.$toast('取消成功');
        }
      })
    },
    getCardList(){
      getCardList({}).then(ret=>{
        if (ret.status == this.$config.ajaxStatus){
          if(ret.data){
            this.cardList = ret.data;
            let btnShow = false;
            ret.data.map(item=>{
              if(item.status == 1){
                btnShow = true;
              }
            })
            this.btnShow = btnShow
          }
        }
      })
    },
  },
  mounted(){
    this.getCardList();
  }
}
</script>
<style lang="less">
  .my-card{
    .card-list{
      padding: 0.2rem;
      .card-list-item{
        border-radius: 0.12rem;
        height: 3.3rem;
        margin-top: 0.2rem;
        color: #fff;
        background-image: url('../../assets/image/card.png');
        background-size: 100% 100%;
        position: relative;
        .card-status{
          padding: 0.3rem 0.2rem;
          font-size: 0.3rem;
          line-height: 0.4rem;
          text-align: right;
        }
        .card-number{
          position: absolute;
          left: 0;
          bottom: 0;
          padding: 0.3rem;
          font-size: 0.36rem;
          line-height: 0.5rem;
        }
      }
      .card-list-item:first-child{
        margin-top: 0;
      }
      .card-list-item.op4{
        opacity: 0.4;
      }
    }
    .btn-box{
      padding: 0.3rem 0.2rem;
    }
    .no-card{
      color: #999;
      text-align: center;
      font-size: 0.24rem;
      padding: 1rem 0;
    }
  }
</style>